export default __webpack_public_path__ + "static/media/spikes_2.bebc2b26.svg";